import React from 'react';

export default ({ color="#000" }) => (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25" width="15" height="15"><path fill={color} d="M7.3 13.6l7.9-7.8 2.5 2.5-7.9 7.8H7.3v-2.5z"/><path fill="none" stroke={color} d="M7.5 19.2h9.2"/></svg>)